module.exports = __webpack_public_path__ + "static/OK-ecd895f443378231ac53a37977625961.svg";